/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_CategoryInputs */

const en_us2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is it about? (optional)`)
};

const pt_br2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o quê? (opcional)`)
};

const es_419_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Sobre qué es? (opcional)`)
};

const pt_pt2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o quê? (opcional)`)
};

const fr_fr2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quel sujet ? (facultatif)`)
};

const de_de2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum geht es? (optional)`)
};

const it_it2_community_suggest_category = /** @type {(inputs: Community_Suggest_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di cosa si tratta? (facoltativo)`)
};

/**
* | output |
* | --- |
* | "What is it about? (optional)" |
*
* @param {Community_Suggest_CategoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_category = /** @type {((inputs?: Community_Suggest_CategoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_CategoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_category(inputs)
	if (locale === "es-419") return es_419_community_suggest_category(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_category(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_category(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_category(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_category(inputs)
	return en_us2_community_suggest_category(inputs)
});
export { community_suggest_category as "community.suggest_category" }